import {API_ENDPOINT_JSON} from './../config';

const bucketUrl = API_ENDPOINT_JSON?.s3_bucket;

export const SampleExcel = {
  facility: {
    default: `${bucketUrl}/Facility.csv`,
    hotel_and_lodge: `${bucketUrl}/FacilityHotel.csv`,
    restaurant: `${bucketUrl}/FacilityRestaurant.csv`
  },
  holding: `${bucketUrl}/Holdings.csv`,
  UpSupplier: `${bucketUrl}/Supplier_Upstream.csv`,
  DownSupplier: `${bucketUrl}/Supplier_Downstream.csv`,
  nonRenewable: `${bucketUrl}/electricitynonrenewable.xlsx`,
  renewable: `${bucketUrl}/electricityrenewable.xlsx`,
  fuelByMachine: `${bucketUrl}/Machine.csv`,
  fuelByRefri: `${bucketUrl}/RefrigerantInfo.csv`,
  fuelByVehicle: `${bucketUrl}/Vehicle.csv`,
  businessTravel: `${bucketUrl}/travelbusiness.xlsx`,
  waste: `${bucketUrl}/waste.xlsx`,
  empTravel: `${bucketUrl}/Employee_Travel.csv`,
  water: `${bucketUrl}/Water.csv`,
  SupplyUpstream: `${bucketUrl}/supplychainupstream.xlsx`,
  SupplyDownstream: `${bucketUrl}/supplychainupstream.xlsx`,
  CapitalGoodsAverage: {
    default: `${bucketUrl}/Capital_Goods_Average.csv`,
    hotel_and_lodge: `${bucketUrl}/capitalgoodaverageHotels%20&%20Lodging.xlsx`,
    restaurant: `${bucketUrl}/capitalgoodaverageRestaurants.xlsx`,
    footwear: `${bucketUrl}/capitalgoodaverageApparel, Accessories & Footwear.xlsx`
  },
  CapitalGoodsSpecific: `${bucketUrl}/capitalgoodsupplierspecific.xlsx`,
  AssetDownProperty: `${bucketUrl}/Asset_Property.csv`,
  AssetDownVehicle: `${bucketUrl}/Asset_Vehicle.csv`,
  AssetFranchise: `${bucketUrl}/Franchise.csv`,
  InvestmentEquity: `${bucketUrl}/investmentequity.xlsx`,
  InvestmentDebt: `${bucketUrl}/investmentdebt.xlsx`,
  InvestmentProjectFinance: `${bucketUrl}/investmentprojectfinance.xlsx`,
  add_userManagement: `${bucketUrl}/User_Management.csv`
};
